import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function apiOrigin() {
  const raw = process.env.REACT_APP_API_URL || '';
  if (/^https?:\/\//i.test(raw)) {
    return raw.replace(/\/api\/v1\/?$/i, '').replace(/\/$/, '');
  }
  return 'https://api.busmgr.com';
}

/** Public SMS short link → API invoice or estimate page. */
export default function PublicSmsLinkRedirect({ kind }) {
  const { token } = useParams();
  const path = kind === 'estimate'
    ? `/api/v1/trades/estimates/public/${encodeURIComponent(token || '')}`
    : `/api/v1/invoices/public/${encodeURIComponent(token || '')}`;
  const href = `${apiOrigin()}${path}`;

  useEffect(() => {
    window.location.replace(href);
  }, [href]);

  return (
    <main style={{ fontFamily: 'Georgia, serif', padding: '2rem', maxWidth: 640, margin: '0 auto' }}>
      <p>Opening your {kind === 'estimate' ? 'estimate' : 'invoice'}…</p>
      <p><a href={href}>Continue</a></p>
    </main>
  );
}
